import { DataTable } from '../components/DataTable.tsx';
import { ErrorState, LoadingState, StatusChip } from '../components/FdPrimitives.tsx';
import { useFetch } from '../hooks/useFetch.ts';

type Decision = {
  request_id: string;
  device_id: string;
  order_id: string;
  arm: string;
  recommendation: string;
  score: number;
  stage: string;
  preauth_recommend: string;
  preauth_arm: string;
  ts: string;
};

// Tone the recover advisory the way an operator reads it: recover = good news
// (we saved a customer), decline = risk, otherwise neutral.
function recoverTone(recommend: string): 'ok' | 'risk' | 'sub' {
  if (recommend === 'recover') return 'ok';
  if (recommend === 'decline') return 'risk';
  return 'sub';
}

export function DecisionsPage() {
  const state = useFetch<{ decisions: Decision[] }>('/decisions');

  if (state.status === 'loading') return <LoadingState label="Loading decisions" />;
  if (state.status === 'error') return <ErrorState message={state.message} />;

  return (
    <div className="page-stack">
      <DataTable
        title="Decisions"
        icon="gavel"
        rows={state.data.decisions}
        emptyTitle="No decisions found"
        emptyMessage="Recent risk decisions will appear when the decision store has tenant data."
        columns={[
          { key: 'request_id', header: 'Request', className: 'cid' },
          { key: 'device_id', header: 'Device', className: 'cid' },
          { key: 'order_id', header: 'Order' },
          { key: 'arm', header: 'Arm', render: (decision) => <StatusChip value={decision.arm} tone="sub" /> },
          { key: 'recommendation', header: 'Verdict', render: (decision) => <StatusChip value={decision.recommendation} /> },
          {
            key: 'stage',
            header: 'Stage',
            render: (decision) =>
              decision.stage === 'pre_auth' ? <StatusChip value="pre-auth" tone="new" /> : (decision.stage || '—'),
          },
          {
            key: 'preauth_recommend',
            header: 'Recover',
            render: (decision) =>
              decision.preauth_recommend
                ? <StatusChip value={decision.preauth_recommend} tone={recoverTone(decision.preauth_recommend)} />
                : '—',
          },
          { key: 'score', header: 'Score' },
          { key: 'ts', header: 'Time' },
        ]}
      />
    </div>
  );
}
